import { render, staticRenderFns } from "./AppSearchAutoSuggestListItem.vue?vue&type=template&id=2a06398a&scoped=true&"
import script from "./AppSearchAutoSuggestListItem.vue?vue&type=script&lang=js&"
export * from "./AppSearchAutoSuggestListItem.vue?vue&type=script&lang=js&"
import style0 from "./AppSearchAutoSuggestListItem.vue?vue&type=style&index=0&id=2a06398a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06398a",
  null
  
)

export default component.exports